import React, { useState, useEffect,useMemo } from "react";
import { HotTable, HotColumn } from "@handsontable/react";

import {
  drawCheckboxInRowHeaders,
  addClassesToRows,
  alignHeaders,
} from "./handsontableHelpers";
import "handsontable/dist/handsontable.min.css";

interface InviteExcelViewProps {
  data: any[];
  membercount: number;
  addition: number;
  SelectValue: string;
  invalidContacts:any[];
  onRowSelect: (rowIndex: number, rowData: any[]) => void;
  onExcelrowClick: (excelrowdata: string) => void;
}

const InviteExcelView: React.FC<InviteExcelViewProps> = ({
  addition,
  membercount,
  data,
  SelectValue,
  invalidContacts,
  onRowSelect,
  onExcelrowClick,
}) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [dataState, setDataState] = useState(data);
  const [copiedOnce, setCopiedOnce] = useState(false);
  const [copyfirst, setcopyfirst] = useState(false);
  const [copyheaders, setcopyheaders] = useState<any[]>([]);
  const [copybody, setcopybody] = useState<any[]>([]);
  
  const [InvalidContacts, setInvalidContacts] = useState<any[]>([]);
  


  useEffect(() => {
    // console.log("받아온 잘못된 전화번호 :  " + invalidContacts)

    setInvalidContacts(invalidContacts)
  }, [invalidContacts]);
  // useEffect(() => {

  //   console.log("현황 " + JSON.stringify(data,null,2))
  // }, [data]);

  
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      // console.log("가로사이즈 : " + window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  
  const columnHeaders = useMemo(() => {
    if (data.length > 0) {
      // console.log("(ExcelView) 헤더 : " +  data[1])
      return data[1];
    }
    return [];
  }, [data]);

  const handleRowSelect = (rowIndex: number, rowData: any[]) => {
    const excelrowdata = JSON.stringify(rowData);
  
    if (excelrowdata) {
      onExcelrowClick(excelrowdata);
    }
  };
  return (
    <div style={{ width: "380px", height: "800px", overflowY: "auto", scrollbarColor: "gray lightgray"}}>
      <HotTable
        data={copiedOnce ? data.slice(2) : data.slice(1)}
        height="100%"
        width="100%"
        
        colHeaders={membercount >= 2 ? data[0] : copiedOnce ? copyheaders : data[0]}

        hiddenColumns={{
          indicators: true,
        }}

        contextMenu={true}
        multiColumnSorting={true}
        rowHeaders={true}
        afterChange={(changes, source) => {
          if (changes) {
            changes.forEach(([row, column, oldValue, newValue]) => {
              if (InvalidContacts.includes(row + 1)) {
                // console.log("변경된 데이터:", oldValue, "->", newValue);
                setInvalidContacts(prevContacts => prevContacts.filter(contact => contact !== row + 1));
              }
            });
          }
        }}
        afterGetColHeader={alignHeaders}
        beforeRenderer={(TD, row, column, prop, value, cellProperties) => {
          
          if (InvalidContacts.includes(row+1)) { // row는 0부터 시작하므로 실제 데이터 행은 row - 1입니다.
            // console.log("row" + (row+1))
            TD.style.backgroundColor = 'red';
          }else{
            TD.style.backgroundColor = '';
          }
        }}
        manualRowMove={true}
        licenseKey="non-commercial-and-evaluation"
        
        afterSelection={(
          r,
          c,
          r2,
          c2,
          preventScrolling,
          selectionLayerLevel,
        ) => {
          const selectedRowData = dataState[r+1];
          onRowSelect(r, selectedRowData);
          handleRowSelect(r, selectedRowData);
        }}
      >
      {Array.from({ length: 3 }, (_, index) => (
        <HotColumn key={index} data={index} />
      ))}
      </HotTable>
    </div>
  );
};

export default InviteExcelView;
